<template>
  <div class="index-w">
      <div class="banner">
        <!-- <el-carousel indicator-position="none" arrow="always" height="650px"> -->
        <el-carousel indicator-position="none" arrow="always" height="33.85416vw">
        <!-- <el-carousel indicator-position="none" arrow="always"> -->
          <el-carousel-item v-for="item in bannerData" :key="item.id">
            <img :src="item.img" alt="">
            <div class="banner-btn" @click="goto(item.topage)"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="about-w">
        <div class="about-l">
          <div class="about-line about-line-t"></div>
          <img src="../../assets/img/index/aboutus.png" alt="关于我们">
          <div class="about-f">
            恒安卫士（深圳）电子科技发展有限公司是北京恒安卫士保安服务有限公司全资子公司，目前北京恒安卫士保安服务有限公司在全国二十个以上的城市开展轨道交通安检服务，作为全国规模最大的轨道交通安检服务供应商，同时也是轨道交通安检设备的实际使用者，我们对各家的安检产品优劣非常了解，2016年北京恒安卫士保安服务有限公司出资在深圳成立全资子公司恒安卫土（深圳）电子科技发展有限公司，自己研发制造自己品牌的×光机系列产品。
          </div>
          <div class="about-btn" @click="goto('/about')"></div>
          <div class="about-line about-line-b"></div>
        </div>
        <div class="about-r">
          <div class="img1"></div>
          <div class="img2"></div>
          <div class="img3"></div>
        </div>
      </div>
      <div class="product-w">
        <div class="product-yx">
          <img src="../../assets/img/index/product-t.png" alt="">
          <div class="product-z">
            <div v-for="i in productData" :key="i.id" @click="goto(i.topage)">
              <img :src="i.img" >
            </div>
          </div>
        </div>
      </div>
      <div class="tech-w">
        <div class="tech-timg"></div>
        <div class="tech-card">
          <el-carousel type="card" indicator-position="none" arrow="none" height="340px" width="600px">
            <el-carousel-item v-for="item in techData" :key="item.id">
              <img :src="item.img" class="tech-img">
              <div class="tech-img-cover" @click="goto(item.topage)">
                <div>{{item.title}}</div>
                <div>{{item.intrd}}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- <div class="tech-w">
        <img src="../../assets/img/index/tech-t.png" alt="">
        <div class="tech-card">
          <el-carousel type="card" indicator-position="none" arrow="none" height="400px" width="550px">
            <el-carousel-item v-for="item in techData" :key="item.id">
              <img :src="item.img" class="tech-img">
              <div class="tech-img-cover" @click="goto(item.topage)">
                <div>{{item.title}}</div>
                <div>{{item.intrd}}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div> -->
      <div class="news-w">
        <div class="news-w-i">
          <div class="news-t"></div>
          <div class="news-cont">
            <div class="cont-l"  @click="goto('/news')">
              <img src="../../assets/img/news/x10.png" class="news-img">
              <div class="contl-t">安全保卫</div>
              <div class="contl-cont">
                &emsp;&emsp;恒安卫士具有先进的安检服务项目管理经验，优秀的管理团队，高素质的安检队伍，安检人员通过安检职业技能培训，持证上岗。<br>
                &emsp;&emsp;国际化、专业化、规范化、现代化的管理手段，标准化的管理体系，使恒安卫士在多年的安保管理服务工作中积累了丰富的经验，熟悉大型临时勤务的策划和执行、地铁安全检查的流程、市政基础设施的守卫、党政机关单位的值守、电力设施的巡视守护、群体性上访的处置等各个环节工作。</div>
            </div>
            <div class="cont-r">
              <div class="contr-w" v-for="item in newsData" :key="item.title" @click="goto(item.topage)">
                <div class="contr-t">{{item.title}}</div>
                <div class="contr-c">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="partner-w">
        <img src="../../assets/img/index/partner.png" alt="">
        <div class="partner-c">
          <img v-for="(item,index) in partnerData" :src="item.url" :key="index" :style="{width: item.width, height: item.height}">
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'index',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      bannerData: [
        {id: 1, img: require('../../assets/img/index/banner1.png'), topage: '/tech/ai'},
        {id: 2, img: require('../../assets/img/index/banner2.png'), topage: '/tech/operate'}
      ],
      productData: [
        {id: 1, img: require('../../assets/img/index/product1.png'), topage: '/product'},
        {id: 2, img: require('../../assets/img/index/product2.png'), topage: '/product'},
        {id: 3, img: require('../../assets/img/index/product3.png'), topage: '/product'},
        {id: 4, img: require('../../assets/img/index/product4.png'), topage: '/product'},
        {id: 5, img: require('../../assets/img/index/product5.png'), topage: '/product'}
      ],
      techData: [
        {id: 1, img: require('../../assets/img/index/x4.png'), topage: '/tech', title: '全国安检运营案例', intrd: '地铁安检信息管理系统，针对地铁安检特点，有效集成、储存、管理地铁站点安检设备信息和安检员工作状态信息，通过监控中心和各安检点间的信息联动，实现地铁安检的立体监控和统一管理。'},
        // {id: 2, img: require('../../assets/img/index/x5.png'), topage: '/tech', title: '集中判图终端', intrd: '1.AI判图服务器对来自多台安检机的X光图进行违禁品识别（在平均100ms内识别23种违禁品并精确标注具体位置），并将X光图和识别结果发送给任务调度服务器。2. 任务调度服务器收到新的判图任务后，根据已登录的一台或多台集中判图终端的忙闲状态合理分配判图任务到各集中判图终端。'},
        {id: 4, img: require('../../assets/img/index/x7.jpg'), topage: '/tech', title: '集中判图平台大屏', intrd: '实现了对安检设备、安检人员、视频监控、安检事件的实时管控，具体包括大数据实时报表式统计分析，AI 辅助判图和集中判图信息，违禁品和违禁品类别占比实时统计图表，行包总数和总报警数统计与展示，判图员资格证，判图员当前正常，离岗、睡岗、缺岗状态，发生故障设备的类、时间、位置和维修责任人联系方式信息，方便后台统一指挥调度管理'},
        // {id: 5, img: require('../../assets/img/index/x8.png'), topage: '/tech', title: '安检业务实时监控大屏', intrd: '统一展示线路级大数据实时统计分析，包括当日报警数、过包数、过人数，违禁品分时统计和区域分布，过人、过包分时统计，各地安检人员、设备和旅客实时动态等。'},
        {id: 3, img: require('../../assets/img/index/x6.jpg'), topage: '/tech', title: '智慧安检开检终端', intrd: '判图员在判图终端上，对显示的带AI标注的X光图逐一做“通过”或“开包检查”处理。开检终端接到开检任务后，自动提取对应的入包图像和出包图像，一并显示在开检终端上，方便开检员对照开包检查。开检终端根据安检机过包序数精确绑定来自入/出包摄像头的入/出包图像。开检员根据开包检查结果，做出“通过”或“处置”的处理。'}
      ],
      newsData: [
        {title: '安全检查', topage: '/news', content: '恒安卫士具有先进的安检服务项目管理经验，优秀的管理团队，高素质的安检队伍，安检人员通过安检职业技能培训，持证上岗。'},
        {title: '智慧安检', topage: '/news', content: '深恒电子科技的智慧安检平台指通过 AI 智能判图边缘计算、集中判图系统、人包绑定、智慧安检门、大数据等多领 域技术的综合运用，研发出轨道交通智慧安检系统，实现轨道交通客户的减员增效，具备国际标准，全方位、全天候智能辅助守护城市安全。'},
        {title: '轨道交通', topage: '/news', content: '恒安卫士现为中国保安协会理事单位、北京保安协会常务理事单位、北京保安协会安全检查服务专业委员会副主任级单位，是中央国家机关保安定点采购单位，在全国有二十余家分公司和办事处，服务客户单位800余家，共计承接27座城市近90多条地铁线路。'}
      ],
      partnerData: [
        {url: require('../../assets/img/index/beijing.png'), width: '127px', height: '121px'},
        {url: require('../../assets/img/index/qingdao.png'), width: '100px', height: '120px'},
        {url: require('../../assets/img/index/guangzhou.png'), width: '127px', height: '120px'},
        {url: require('../../assets/img/index/shenzhen.png'), width: '128px', height: '115px'},
        {url: require('../../assets/img/index/zhonghang.png'), width: '189px', height: '120px'},
        {url: require('../../assets/img/index/logo-22.png'), width: '165px', height: '122px'},
        {url: require('../../assets/img/index/logo-27.png'), width: '126px', height: '120px'},
        {url: require('../../assets/img/index/logo-29.png'), width: '130px', height: '120px'}
      ]
    }
  },
  methods: {
    goto (parameter) {
      // this.$router.push({path: '/about'})
      this.$router.push({path: parameter})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.banner{
  width: 100%;
  height: 650px;
  position: relative;
}
.banner img{
  width: 100%;
}
.banner-btn{
  width: 162px;
  height: 50px;
  border-radius: 50px;
  position: absolute;
  left: 355px;
  top: 456px;
  background: url('../../assets/img/index/banner-butt.png');
  background-size: 100%;
}
.banner-btn:hover{
  background: url('../../assets/img/index/banner-butt-hit.png');
  background-size: 100%;
}
.about-w{
  width: 1200px;
  height: 814px;
  margin: 0 auto;
  position: relative;
}
.about-l{
  position: absolute;
  left: 0;
  top: 0;
  width: 526px;
  height: 100%;
}
.about-line{
  width: 1px;
  height: 175px;
  background: #ccc;
  position: absolute;
  left: 40px;
}
.about-line-t{ top: 0; }
.about-line-b{ bottom: 0; }
.about-l img{
  position: absolute;
  top:238px;
  left: 0;
}
.about-f{
  position: absolute;
  top: 330px;
  left: 0;
  width: 526px;
  height: 164px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}
.about-btn{
  position: absolute;
  left: 0;
  bottom: 200px;
  width: 132px;
  height: 50px;
  background: url('../../assets/img/index/btn2.png');
  background-size: 100%;
}
.about-btn:hover{
  background: url('../../assets/img/index/btn1.png');
}
.about-r{
  position: absolute;
  right: 0;
  top: 122px;
  width: 544px;
  height: 531px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.about-r div{
  display: inline-block;
  background-size: 100% 100%;
  border: 1px dashed #333;
}
.img1{
  width: 100%;
  height: 236px;
  background: url('../../assets/img/index/x1.png');
  margin-bottom: 13px;
}
.img2{
  width: 320px;
  height: 282px;
  background: url('../../assets/img/index/x2.png');
  /* margin-right: 12px; */
}
.img3{
  width: 199px;
  height: 282px;
  background: url('../../assets/img/index/x3.png');
}
.product-w{
  width: 100%;
  height: 750px;
  background-image: linear-gradient(to right, #001a5c , #0561a8);
}
.product-yx{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.product-yx >img{
  position: absolute;
  top: 98px;
  width: 100%;
}
.product-z{
  width: 100%;
  height: 350px;
  position: absolute;
  top: 230px;
  display: flex;
  justify-content: space-between;
}
.product-z div{
  width: 200px;
  height: 350px;
  background: #fff;
}
.product-z div>img{
  width: 100%;
}
.tech-w{
  width: 1200px;
  margin: 123px auto 188px;
}
.tech-timg{
  width: 100%;
  height: 65px;
  margin: 0 auto;
  background: url('../../assets/img/index/tech-t.png');
  background-size: 100%;
}
.tech-c{
  width: 100%;
  margin: 0 auto;
}
.tech-card{
  width: 1200px;
}
.tech-img{
  width: 600px;
  height: 340px;
}
.tech-img-cover{
  width: 600px;
  height: 340px;
  background: rgba(3, 3, 3, 0.7);
  position: absolute;
  top:0;
  left: 0;
  opacity: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tech-img-cover:hover{
  opacity: 1;
}
.tech-img-cover div{
  margin: 0 auto;
  width: 355px;
  color: #fff;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
}
.news-w{
  width: 100%;
  height: 700px;
  background:#F8F8F8 ;
}
.news-w-i{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 90px 0 119px;
}
.news-t{
  width: 120px;
  height: 40px;
  background: url('../../assets/img/index/news-t.png');
  background-size: 100%;
  margin-bottom: 46px;
}
.news-cont{
  display: flex;
  justify-content: space-between;
}
.cont-l{
  width: 550px;
  background: #fff;
}
.news-img{
  width: 100%;
  height: 250px;
}
.contl-t{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #323333;
  line-height: 69px;
  padding-left: 22px;
}
.contl-cont{
  width: 100%;
  font-size: 12px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #666666;
  line-height: 20px;
  padding: 0 22px 42px;
}
.cont-r{
  width: 510px;
}
.contr-w{
  width: 100%;
}
.contr-t{
  width: 100%;
  height: 19px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #323333;
  line-height: 19px;
  margin-bottom: 20px;
}
.contr-c{
  width: 100%;
  height: 71px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  border-bottom: 1px solid #E6E6E6;
  margin-bottom: 40px;
}
.partner-w{
  width: 1200px;
  margin: 80px auto 110px;
}
.partner-w img{
  width: 100%;
}
.partner-c{
  width: 100%;
  /* height: 550px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.partner-c img{
  display: inline-block;
  margin: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/index.vue